export const SET_REFUNDED_ORDER_ITEMS = "SET_REFUNDED_ORDER_ITEMS";
export const FETCH_CANCELLATION_REASONS_PENDING = "FETCH_CANCELLATION_REASONS_PENDING";
export const FETCH_CANCELLATION_REASONS_FULFILLED = "FETCH_CANCELLATION_REASONS_FULFILLED";
export const FETCH_ORDER_REFUND_PENDING = "FETCH_ORDER_REFUND_PENDING";
export const FETCH_ORDER_REFUND_REJECTED = "FETCH_ORDER_REFUND_REJECTED";
export const FETCH_ORDER_REFUND_FULFILLED = "FETCH_ORDER_REFUND_FULFILLED";



// WEBPACK FOOTER //
// ./src/constants/orderRefund.js